/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trackingtable_Emptystate_Prospectslinktext3Inputs */

const en_trackingtable_emptystate_prospectslinktext3 = /** @type {(inputs: Trackingtable_Emptystate_Prospectslinktext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prospects`)
};

/**
* | output |
* | --- |
* | "prospects" |
*
* @param {Trackingtable_Emptystate_Prospectslinktext3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const trackingtable_emptystate_prospectslinktext3 = /** @type {((inputs?: Trackingtable_Emptystate_Prospectslinktext3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trackingtable_Emptystate_Prospectslinktext3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_trackingtable_emptystate_prospectslinktext3(inputs)
});
export { trackingtable_emptystate_prospectslinktext3 as "trackingtable_emptyState_prospectsLinkText" }